import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useLoginCookie from "shared/model/useLoginCookie"
import useRoleCookie from "shared/model/useRoleCookie"

const useDeleteAccount = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteLoginCookie] = useLoginCookie()
    const [, , deleteRoleCookie] = useRoleCookie()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("DELETE", "/account")
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setAlert("정상적으로 탈퇴 처리 되었습니다.")
                deleteLoginCookie()
                deleteRoleCookie()
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("계정 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default useDeleteAccount